<template lang="pug">
.send-message-target-modal
  b-modal(v-model="_show" size="lg" @ok="add" @cancel="cancel")
    template(#modal-header="{ cancel }")
      .send-message-target-modal-header.d-flex.flex-row.align-items-center
        span.menu-title.flex-grow-1 宛先を選択してください。
      button.close(type="button" @click="cancel") ×

    .send-message-target-modal-body
      //- group name, group member name filter
      .mb-2.d-flex.flex-row.align-items-center
        b-form-input(id="text-filter" v-model="filter.text" name="text-filter" placeholder="施設関係者グループ・氏名を検索" aria-describedby="text-filter" data-vv-as="テキスト検索")
      //- list
      b-list-group
        template(v-if="group.show == true" v-for="group in _value")
          b-list-group-item.list-group-title
            span {{ group.name }}
          b-list-group-item(v-if="member.show == true" v-for="member in group.targets" :key="member.id + '-' + member.memberId")
            b-form-checkbox(v-model="member.isTarget" v-if="member.senderType == 0" size="sm") {{ member.memberName }}
            b-form-checkbox(v-model="member.isTarget" v-if="member.senderType == 1" size="sm") {{ member.memberName }}（メール）

    template(#modal-footer="{ ok, cancel }")
      b-button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      b-button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      b-button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import OtherUserGroup from "@/commons/models/OtherUserGroup";

/**
 * 「施設関係者」宛先リストモーダル
 */
@Component
export default class SendMessageTargetOtherUserModal extends Vue {
  /** ### 宛先候補 */
  @Prop()
  value!: Array<SendMessageTargetOtherUserModalModel>;
  /** ### 表示可否 */
  @Prop()
  show!: boolean;

  /** フィルタ */
  filter: { text: string } = { text: "" };

  get _value(): Array<SendMessageTargetOtherUserModalModel> {
    // テキスト検索==空の場合は全て表示する
    if (this.filter.text == "") {
      for (const group of this.value) {
        group.show = true;
        for (const target of group.targets) {
          target.show = true;
        }
      }
    }
    // テキスト検索!=空の場合はキーワードでフィルタリングして表示する
    else if (this.filter.text != "") {
      const words: string[] = this.$filterUtil.createSearchWord(this.filter.text);
      for (const group of this.value) {
        let groupShow: boolean = false;
        for (const target of group.targets) {
          for (const word of words) {
            if (-1 < target.name.indexOf(word)) {
              target.show = true;
              groupShow = true;
              break;
            }
            if (-1 < target.memberName.indexOf(word)) {
              target.show = true;
              groupShow = true;
              break;
            }
            target.show = false;
          }
        }
        group.show = groupShow;
      }
    }

    return this.value;
  }

  get _show(): boolean {
    return this.show;
  }

  set _show(newValue: boolean) {
    this.$emit("update:show", newValue);
    return;
  }

  get _checked(): boolean {
    for (const resident of this.value) {
      for (const family of resident.targets) {
        if (family.isTarget == true) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * ### OKボタン押下イベント
   */
  public add(): void {
    this.filter.text = "";
    this.$emit("add");
    return;
  }

  /**
   * ### キャンセルボタン押下イベント
   */
  public cancel(): void {
    this.filter.text = "";
    this.$emit("cancel");
    return;
  }
}

export interface SendMessageTargetOtherUserModalModel {
  name: string;
  targets: Array<SendMessageTargetOtherUserModel>;
  show: boolean;
}
export interface SendMessageTargetOtherUserModel extends OtherUserGroup {
  isTarget: boolean;
  show: boolean;
}
</script>

<style lang="scss" scopeed>
@import "../../../styles/mobile/_colors.scss";

.send-message-target-modal-body {
  .list-group-title {
    color: $font-accordion !important;
    background-color: $bg-accordion !important;
  }
}
</style>
